import { InputControlMask } from './InputControlMask';
import { Tooltip } from './Tooltip';
import { IoIosSearch } from 'react-icons/io';
import CurrencyFormat from 'react-currency-format';

const Input = ({
    id,
    field,
    label = '',
    type = 'text',
    placeholder = '',
    value,
    isRequired = true,
    isReadOnly = false,
    onChange,
    mask,
    pattern,
    title,
    onlyInput = false,
    cssClassStyle = '',
    useToolTip = false,
    textToolTip = '',
    titleToolTip = '',
    useIconSearch = false,
    onClickIconSeach = () => {},
    maxValue,
    prefix = ''
}: IPropsInput) => {

    const cssInput = `input-field-auto-cr ${cssClassStyle}`;
    const inputContainerClass = useToolTip ? 'w-icon' : '';

    const handleSearchClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onClickIconSeach();
    };

    const renderInput = () => {
        const sharedProps = {
            id,
            name: field,
            placeholder,
            value,
            required: isRequired,
            onChange,
            readOnly: isReadOnly,
            className: cssInput,
            autoComplete: 'off',
        };

        switch (type) {
            case 'textarea':
                return (
                    <textarea
                        {...sharedProps}
                        className={`${cssInput} input-field-area-re-ni`}
                        wrap='hard'
                    />
                );

            case 'email':
                return (
                    <input
                        {...sharedProps}
                        type="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    />
                );

            case 'number':
                return (
                    <input
                        {...sharedProps}
                        type="number"
                        min={0}
                        max={maxValue}
                        title="Campo requerido"
                    />
                );

            case 'mask':
                return (
                    <InputControlMask
                        {...sharedProps}
                        type="text"
                        mask={mask}
                        pattern={pattern}
                        title={title}
                    />
                );

            case 'CURRENCY_FORMAT':
                return (
                    <CurrencyFormat
                        id={id}
                        name={field}
                        decimalScale={2}
                        prefix={prefix}
                        value={value}
                        required={isRequired}
                        className={cssInput}
                        allowNegative={false}
                        readOnly={isReadOnly}
                        thousandSeparator
                        autoComplete="off"
                        onValueChange={(e) => 
                            { console.log(e)
                                onChange(field, e.value)}
                            }
                    />
                );

            case 'text':
            case 'textSearch':
            default:
                return (
                    <input
                        {...sharedProps}
                        type="text"
                        title="Campo requerido"
                    />
                );
        }
    };

    return (
        <>
            {!onlyInput && (
                <div className="lbl-input-auto-cr mt-10 mb-5" style={{ display: "flex" }}>
                    <span>{label} {isRequired && <span style={{ color: '#FF5F49' }}>*</span>}</span>
                    {useToolTip && (
                        <Tooltip id={field} key={field} text={textToolTip} title={titleToolTip} />
                    )}
                </div>
            )}
            <div className={`mb-10 ${inputContainerClass}`}>
                {renderInput()}
                {useIconSearch && <IoIosSearch className="icon-search-nr" onClick={handleSearchClick} />}
            </div>
        </>
    );
};

export { Input };